import React from 'react';
import { Link } from 'react-router-dom';
import { Youtube } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 py-12">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <h3 className="text-white font-semibold mb-3">ContextUI</h3>
            <p className="text-gray-400 text-sm">
              The Do-Any-Task Workspace.
            </p>
          </div>

          {/* Product Links */}
          <div>
            <h3 className="text-white font-semibold mb-3">Product</h3>
            <ul className="space-y-2">
              <li><Link to="/download" className="text-gray-400 hover:text-white text-sm">Download</Link></li>
              <li><Link to="/exchange" className="text-gray-400 hover:text-white text-sm">Exchange</Link></li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-white font-semibold mb-3">Resources</h3>
            <ul className="space-y-2">
              <li><Link to="/docs" className="text-gray-400 hover:text-white text-sm">Documentation</Link></li>
              <li><Link to="/support" className="text-gray-400 hover:text-white text-sm">Support</Link></li>
              <li><Link to="/release-notes" className="text-gray-400 hover:text-white text-sm">Release Notes</Link></li>
              <li><Link to="/attributions" className="text-gray-400 hover:text-white text-sm">Attributions</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-white font-semibold mb-3">Legal</h3>
            <ul className="space-y-2">
              <li><Link to="/terms" className="text-gray-400 hover:text-white text-sm">Terms of Service</Link></li>
              <li><Link to="/privacy" className="text-gray-400 hover:text-white text-sm">Privacy Policy</Link></li>
              <li><Link to="/license" className="text-gray-400 hover:text-white text-sm">Open Source License</Link></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} Intelligent System Design Pty Ltd. Licensed under Apache 2.0.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0 items-center">
              <a
                href="https://www.youtube.com/@ContextUI"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
                aria-label="YouTube Channel"
              >
                <Youtube className="w-5 h-5" />
              </a>
              <a href="mailto:support@isd.ai" className="text-gray-400 hover:text-white text-sm">Contact</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;